import { createApp } from 'vue'

import App from './App.vue'
import store from './store'
import router from './router'
import SynoVueComponents from '@synology/SynoVueComponents/vue3'
import '@synology/svc-theme-default'
import '@synology-drive/svc-theme-drive'
import './style/index.scss'

const app = createApp(App)

app.use(store)
   .use(router)
   .use(SynoVueComponents)
   .provide('windowMgr', app.config.globalProperties.$windowManager)
   .mount('#app')
